import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { MEMORIES, MEMORY_TAGS } from "../data/bookData";

export const MemoriesGallery = () => {
  const [tag, setTag] = useState("All");
  const [active, setActive] = useState(null);
  const shown = tag === "All" ? MEMORIES : MEMORIES.filter((m) => m.tag === tag);

  return (
    <section data-testid="memories-section" className="relative px-6 py-24 sm:py-32">
      <div className="mx-auto max-w-5xl">
        <div className="text-center">
          <p className="font-hand text-2xl text-[#C87D87]">little pieces of us</p>
          <h2 className="mt-3 font-display text-2xl font-semibold sm:text-3xl lg:text-4xl">The Memory Wall</h2>
          <div className="mt-8 flex flex-wrap justify-center gap-2.5">
            {MEMORY_TAGS.map((t) => (
              <button
                key={t}
                data-testid={`memory-filter-${t.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setTag(t)}
                className={`rounded-full px-5 py-2 text-xs font-semibold transition-all ${
                  tag === t
                    ? "bg-[#C87D87] text-[#FFFDF9] shadow-md"
                    : "border border-[#E8B4B8]/60 bg-[#FFFDF9]/70 text-[#4A2E35]/70 hover:bg-[#FAE3E8]"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-6 sm:grid-cols-3 sm:gap-10">
          {shown.map((m, i) => (
            <button
              key={m.src + m.caption}
              data-testid="polaroid-item-frame"
              onClick={() => setActive(m)}
              className="polaroid relative"
              style={{ transform: `rotate(${(i % 2 === 0 ? -1 : 1) * (1.5 + (i % 3))}deg)` }}
            >
              <span className="tape" />
              <img src={m.src} alt={m.caption} loading="lazy" className="aspect-square w-full object-cover" />
              <p className="py-3 text-center font-hand text-lg leading-tight text-[#4A2E35]/80">{m.caption}</p>
            </button>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-[#362428]/70 p-6 backdrop-blur-sm"
            onClick={() => setActive(null)}
            data-testid="polaroid-modal"
          >
            <motion.div
              initial={{ scale: 0.85, rotate: -2 }}
              animate={{ scale: 1, rotate: 0 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="polaroid relative max-w-md"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={active.src} alt={active.caption} className="w-full object-cover" />
              <p className="py-4 text-center font-hand text-xl text-[#4A2E35]/85">{active.caption}</p>
              <button
                data-testid="polaroid-modal-close-btn"
                onClick={() => setActive(null)}
                aria-label="Close photo"
                className="absolute -right-3 -top-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#C87D87] text-[#FFFDF9] shadow-lg transition-transform hover:scale-110"
              >
                <X size={16} />
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
